import React from "react";
import Box from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Paper from "Components/UI/Paper";
import { CreateUserForm } from "./components/CreateUserForm";
import { getUserTypes } from "API/swesum";

export async function loader() {
  const userTypes = await getUserTypes();
  return { userTypes };
}

export function CreateUser() {
  return (
    <>
      <Box component="main" sx={{ flexGrow: 1, p: 5 }}>
        <Grid item xs={12} md={12}>
          <Paper>
            <Typography sx={{ marginBottom: "2rem" }} variant="h5">
              Skapa användare
            </Typography>
            <CreateUserForm />
          </Paper>
        </Grid>
      </Box>
    </>
  );
}
